<template>
  <header>
    <b-container class="navbar">
        <div class="brand">
          <a href="https://www.sgrlucegas.com"><img alt="SGR Luce & Gas" src="@/assets/images/logo.svg"></a>
        </div>
        <div class="buttons">
          <b-button v-b-modal.modal-chat variant="link"><img src="@/assets/icons/chat.svg"></b-button>
          <!--b-button variant="link" href="https://www.sgrlucegas.com/"><img src="@/assets/icons/exit.svg"></b-button-->
        </div>
    </b-container>

    <b-modal id="modal-chat" modal-class="modal-full" scrollable :hide-footer="true">
      <div slot="modal-header-close">
        <img src="@/assets/icons/exit.svg">
      </div>
      <form-help></form-help>
    </b-modal>

  </header>
</template>

<script>
import FormHelp from "@/views/steps/Forms/Help";
export default {
  name: "HeaderComponent",
  components: {FormHelp}
}
</script>

<style scoped lang="scss">
header {
  padding: 4px 24px;
  border-bottom: 1px solid #0000001A;
  height: 64px;
  display: flex;
  align-items: center;

  .navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;

    .brand {
      img {
        height: 60px;
        @media (max-height: 568px) {
          height: 40px;
        }
      }
    }
    .buttons{
      display: flex;
      align-items: center;
      gap: 20px;
      button{
        padding: 0;
      }
    }
  }
}
@media (max-width: 991px) {
  header {
  }
}
</style>